import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hd-epic-primary-endpoint-over-time-frame hd-epic-frame-content" }
const _hoisted_2 = { class: "hd-epic__header" }
const _hoisted_3 = { class: "hd-epic__content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_lyra_asset, {
        class: "hd-epic__header-section",
        "asset-key": `epic-header-section-${_ctx.section}`
      }, null, 8, ["asset-key"]),
      _createVNode(_component_lyra_asset, {
        class: "hd-epic__header-title",
        "asset-key": "epic-header-primary-endpoint-over-time-title"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_lyra_asset, {
        class: "hd-epic__content-svg",
        "asset-key": "epic-primary-endpoint-over-time-svg"
      })
    ])
  ]))
}